import { z } from "zod";

export const productDoseBaseEnum = z.enum(["kg-of-patient-weight", "patient"]);

export type ProductDoseBaseType = z.infer<typeof productDoseBaseEnum>;

// t("kg-of-patient-weight")
// t("patient")
